import { z } from 'zod';

const tokenStatusesShema = z.object({
  doc_requested: z.boolean(),
  is_blocked_by_client: z.boolean(),
  is_blocked_by_risk: z.boolean(),
  is_first_deposit: z.boolean(),
  is_first_payout: z.boolean(),
  is_new: z.boolean(),
  is_verified: z.boolean()
});

export const rixusPaymentTokenObjectShema = z.object({
  cpf_number: z.string(),
  pix_key: z.string(),
  pix_key_type: z.string()
});

export const IMPSPaymentTokenObjectShema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  ifsc_code: z.string()
});

export const tokenShema = z.object({
  name: z.string(),
  paymentToken: z.string(),
  statuses: tokenStatusesShema.optional(),
  paymentTokenObject: z
    .union([rixusPaymentTokenObjectShema, IMPSPaymentTokenObjectShema])
    .optional(),
  hasNtf: z.boolean().optional()
});

export const getTokenResponseDataShema = z.object({
  response: z.array(tokenShema),
  error: z.string(),
  error_code: z.string()
});

export const addTokenResponseDataShema = z.object({
  response: z.object({
    paymentToken: z.string()
  }),
  error: z.string(),
  error_code: z.string()
});

export const updateTokenResponseDataShema = z.object({
  response: z.string().nullable(),
  error: z.string(),
  error_code: z.string()
});
